(() => {
  // temp fix
  const page = new URLSearchParams(window.location.search).get('page')
  if (page !== null && Number(page) > 1) {
    window.location.replace(updateQueryStringParameter(window.location.href, 'page', 1))
  }
})();

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  }
  else {
    return uri + separator + key + "=" + value;
  }
}

function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function getExcessWidth() {
  const viewportWidth = window.innerWidth
  const containerWidth = document.querySelector('.spt-container')
    .offsetWidth
  return (viewportWidth - containerWidth) / 2
}


async function callRetry (fn, depth = 0) {
  const wait = (ms) => new Promise((res) => setTimeout(res, ms));

  try {
    return await fn();
  } catch(e) {
    if (depth > 8) { throw e }
    await wait(2 ** depth * 1000);
    return callRetry(fn, depth + 1);
  }
}

window.cym = {};
// add helper function for firing GA events
const gaEvent = (category, action, label = '') => {
  console.log('event category:', category);
  console.log('event action:', action);
  console.log('event label', label);
  try {
    gtag('event', action, {
      event_category: category,
      event_label: label
    });
  } catch {
    console.log('Error Block');
  }
};

window.cym.event = gaEvent;

// Put this in the cart
window.addEventListener('DOMContentLoaded', () => {
  // init cart drawer events
  const initCartDrawer = () => {
    const root = document.querySelector('#drawer-cart__root');
    const overlay = document.querySelector('#drawer-cart__overlay');
    const container = document.querySelector('#drawer-cart');

    const navCartBtn = document.querySelector('button#navbar__cart');

    const open = () => {
      document.body.classList.add('spt-overflow-hidden');

      overlay.classList.remove('spt-invisible');
      overlay.style.opacity = 1;
      container.style.right = 0;
      container.focus();
    };
    const close = () => {
      document.body.classList.remove('spt-overflow-hidden');

      overlay.classList.add('spt-invisible');
      overlay.style.opacity = 0;
      container.style.right = `-${container.offsetWidth}px`;
    };

    const toggle = dir => {
      if (overlay.style.opacity === '0') {
        open();
      } else {
        close();
      }
    };
    navCartBtn.addEventListener('click', toggle);
    overlay.addEventListener('click', toggle);

    window.addEventListener('resize', () => {
      if (overlay.style.opacity === '0') {
        container.style.right = `-${container.offsetWidth}px`;
      }
    });

    container.style.right = `-${container.offsetWidth}px`;

    document.addEventListener('keydown', e => {
      if (e.keyCode == 27) {
        close();
      }
    });
    // event for button in vue cart
    window.cym.toggleCartDrawer = toggle;

    // open with no transition
    if (new URL(window.location.href).searchParams.get('cart') !== null) {
      overlay.classList.toggle('nav-transition', false);
      container.classList.toggle('nav-transition', false);
      toggle();
      overlay.classList.toggle('nav-transition', true);
      container.classList.toggle('nav-transition', true);
    }
  };

  // Put this in the cart

  // Put this in the search drawer
  const initSearchDrawer = () => {
    const root = document.querySelector('#drawer-search__root');
    const overlay = document.querySelector('#drawer-search__overlay');
    const container = document.querySelector('#drawer-search');

    const open = () => {
      document.body.classList.add('spt-overflow-hidden');

      overlay.classList.remove('spt-invisible');
      overlay.style.opacity = 1;
      container.style.right = 0;
      document.querySelector('#drawer-search input#Search').focus();
    };
    const close = () => {
      document.body.classList.remove('spt-overflow-hidden');

      overlay.classList.add('spt-invisible');
      overlay.style.opacity = 0;
      container.style.right = `-${container.offsetWidth}px`;
    };

    const toggle = dir => {
      if (overlay.style.opacity === '0') {
        open();
      } else {
        close();
      }
    };

    let pollingInterval;
    let pollingDuration = 10000; // 10 seconds
    let pollingIntervalTime = 500; // 500ms

    function pollForDoofinder() {
      if (typeof(window.doofinderLoader) != 'undefined') {
        clearInterval(pollingInterval);

        let navbarSearch = document.querySelector('button#navbar__search');
        let navpanelSearch = document.querySelector('button#navpanel__search');
        let navbarMobileSearch = document.querySelector('button#navbar-mobile__search');
        let navbarSearchCopy = navbarSearch;
        let navpanelSearchCopy = navpanelSearch;
        let navbarMobileSearchCopy = navbarMobileSearch
        let navbarParent = navbarSearch.parentElement;
        let navpanelParent = navpanelSearch.parentElement;
        let navbarMobileParent = navbarMobileSearch.parentElement;
        let searchInput = document.querySelector('input[id="Search"]');
        let navpanelOverlay = document.getElementById('navpanel__overlay');
        
        navbarParent.insertAdjacentHTML('beforeend', navbarSearchCopy.outerHTML);
        navpanelParent.insertAdjacentHTML('beforeend', navpanelSearchCopy.outerHTML);
        navbarMobileParent.insertAdjacentHTML('beforeend', navbarMobileSearchCopy.outerHTML);
        navbarSearch.remove();
        navpanelSearch.remove();
        navbarMobileSearch.remove();
        navbarSearchCopy = document.querySelector('button#navbar__search');
        navpanelSearchCopy = document.querySelector('button#navpanel__search');
        navbarMobileSearchCopy = document.querySelector('button#navbar-mobile__search')
        navbarSearchCopy.addEventListener('click', () => {
          searchInput.click();
        });
        navpanelSearchCopy.addEventListener('click', () => {
          navpanelOverlay.click();
          searchInput.click();
        });
        navbarMobileSearchCopy.addEventListener('click', () => {
          searchInput.click();
        });
      }
    }

    pollingInterval = setInterval(pollForDoofinder, pollingIntervalTime);

    setTimeout(() => {
      clearInterval(pollingInterval);
    }, pollingDuration);

    document
      .querySelector('button#navbar__search')
      .addEventListener('click', toggle);
    document
      .querySelector('button#navpanel__search')
      .addEventListener('click', toggle);
    document
      .querySelector('button#navbar-mobile__search')
      .addEventListener('click', toggle);
    document
      .querySelector('button#search-close')
      .addEventListener('click', toggle);
    overlay.addEventListener('click', toggle);

    window.addEventListener('resize', () => {
      if (overlay.style.opacity === '0') {
        container.style.right = `-${container.offsetWidth}px`;
      }
    });

    container.style.right = `-${container.offsetWidth}px`;

    document.addEventListener('keydown', e => {
      if (e.keyCode == 27) {
        close();
      }
    });

    const search = async q => {
      // Define the base URL and parameters
      const baseUrl = '/search/suggest.json';
      const queryParams = {
        q,
        'resources[type]': 'product,article',
        'resources[options][fields]': 'body,product_type,tag,title,variants.title'
      };
    
      // Convert the parameters object into a query string
      const queryString = new URLSearchParams(queryParams).toString();
      const urlWithParams = `${baseUrl}?${queryString}`;
    
      // Define the fetch options, mimicking the original config structure
      const fetchOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      };
    
      // Perform the fetch request
      const response = await fetch(urlWithParams, fetchOptions);
      return await response.json(); // Parse and return the JSON response
    };
    
    
    const clearResults = () => {
      document
        .querySelector('#drawer-search .search-no-results')
        .classList.add('spt-hidden');
      document.querySelector('#drawer-search .search-results').innerHTML = '';
    };
    const setResult = (result, type) => {
      // console.log("result and type", result, type)
      if (result.price === '0.00') {
        return;
      }
      const regex = /<[^>]*>/gm;

      const resultEl = document.createElement('div');
      resultEl.classList.add(
        'spt-pb-6.5',
        'md:spt-pb-7.5',
        'spt-border-b',
        'spt-border-cym-lightgrey'
      );

      const bodyText = result.body.replaceAll(regex, '');

      resultEl.innerHTML = `
        <a href="${result.url}" title="${result.title}">
          <div class="search-result">
            <div class="spt-aspect-square spt-h-[5rem] md:spt-h-[7.5rem] spt-bg-cym-lightgrey spt-rounded-md">
              <img
                class="${!result.image ? 'spt-hidden' : ''
        } spt-w-full spt-h-full spt-object-cover spt-rounded-md spt-border spt-border-cym-lightgrey"
                src="${result.image}"
                alt="Image for ${result.title}"
              >
            </div>
            <div class="spt-grow spt-flex spt-flex-col spt-gap-2 md:spt-gap-2.5">
              <span class="spt-uppercase spt-text-cym-grey spt-cym-h-3-sm md:spt-cym-h-3 xl:spt-cym-h-3-lg">
                ${type}
              </span>
              <div class="spt-cym-h-2-sm md:spt-cym-h-2 xl:spt-cym-h-2-lg">
                ${result.title}
              </div>
              <div class="spt-cym-p-1-sm xl:spt-cym-p-1">
                ${bodyText.length > 100 ? bodyText.slice(0, 100) : bodyText}${bodyText.length > 100 ? '...' : ''
        }
              </div>
            </div>
          </div>
        </a>
      `;
      document
        .querySelector('#drawer-search .search-results')
        .appendChild(resultEl);
    };
    const setNoResults = q => {
      document
        .querySelector('#drawer-search .search-no-results')
        .classList.remove('spt-hidden');
      document.querySelector(
        '#drawer-search .no-results-msg'
      ).innerHTML = `We could not find any results with “${q}”`;
    };

    const submitSearch = async () => {
      clearResults();

      const spinner = document.querySelector('#drawer-search .loading');
      spinner.style.height = '1rem';

      const input = document.querySelector('#drawer-search input#Search');

      if (!input.value) {
        spinner.style.height = null;
        document.querySelector('#drawer-search input#Search').focus();
        return;
      }

      try {
        await search(input.value).then(r => {
          console.log("result", r.resources)
          const products = r.resources.results.products;

          const articles = r.resources.results.articles;

          const results = products.concat(articles);

          for (const result of products) {
            setResult(result, 'product');
          }
          for (const result of articles) {
            setResult(result, 'article');
          }
          if (results.length === 0) {
            setNoResults(input.value);
          }
        });
      } finally {
        spinner.style.height = null;
      }
    };

    document
      .querySelector('#drawer-search button#search-submit')
      .addEventListener('click', submitSearch);
    document
      .querySelector('#drawer-search input#Search')
      .addEventListener('keypress', e => {
        if (e.key === 'Enter') {
          submitSearch();
        }
      });
    document
      .querySelector('#drawer-search button#search-submit')
      .addEventListener('click', submitSearch);
  };

  // Put this in the search drawer

  // put footer events in footer file
  // init footer events
  const initFooterLinks = () => {
    const drawerOpenClose = e => {
      if (document.body.offsetWidth < 768) {
        const itemsCont = e.target
          .closest('.footer__linklist-header')
          .parentNode.querySelector('.footer__linklist-items');
        const arrow = e.target
          .closest('.footer__linklist-header')
          .parentNode.querySelector('.icon-chevron-right');
        if (itemsCont.style.maxHeight === '') {
          // something taller than the drawers will ever be
          itemsCont.style.maxHeight = '500px';
          itemsCont.classList.add('spt-mb-5');
          arrow.classList.add('spt-rotate-270');
          arrow.classList.remove('spt-rotate-90');
        } else {
          itemsCont.style.maxHeight = '';
          itemsCont.classList.remove('spt-mb-5');
          arrow.classList.remove('spt-rotate-270');
          arrow.classList.add('spt-rotate-90');
        }
      }
    };

    document.querySelectorAll('.footer__linklist-header').forEach(el => {
      el.onclick = drawerOpenClose;
    });
  };
  // put footer events in footer file

  // put in nav drawer file
  // init nav drawer events
  const initNavDrawer = () => {
    // new SimpleBar(document.querySelector('.navpanel-top-section'));

    const navMegasMinis = [
      ...document.querySelectorAll('.navbar__item-mega')
    ].concat([...document.querySelectorAll('.navbar__item-mini')]);
    navMegasMinis.forEach(el => {
      el.classList.remove('spt-hidden');
    });

    const root = document.querySelector('#navpanel__root');
    const overlay = document.querySelector('#navpanel__overlay');
    const container = document.querySelector('#navpanel');

    const navPanelItems = document.querySelector('#navpanel__items');

    const navbarOpenBtn = document.querySelector(
      '#navbar__left .icon-menu'
    ).parentNode;
    const navbarCloseBtn = document.querySelector(
      '#navbar__left .icon-close'
    ).parentNode;
    const navbarBackBtn = document.querySelector(
      '#navbar__left .icon-chevron-left'
    ).parentNode;

    const navPanelCloseBtn = document.querySelector(
      '#navpanel .icon-close'
    ).parentNode;
    const navPanelBackBtn = document.querySelector(
      '#navpanel .icon-chevron-left'
    ).parentNode;

    const announcementBar = document.querySelector('.announcement-bar');

    const miniToggle = (el, dir) => { // el is event object
      if (dir !== 'close') { //toggle minis individually
        const panelItem = el.target
          .closest('.navpanel__item')
        const mini = panelItem
          .querySelector('.navpanel__item-mini')
        const chevron = panelItem.querySelector('svg.icon-chevron-right')
        if (!mini.style.maxHeight) { //mini closed
          mini.style.maxHeight = '500px';
          // flip direction of chevron icon
          chevron.classList.toggle('spt-rotate-270')
          chevron.classList.toggle('spt-rotate-90')
        } else { // mini already open
          mini.style.maxHeight = null;
          // flip chevron
          chevron.classList.toggle('spt-rotate-90')
          chevron.classList.toggle('spt-rotate-270')
        }
      } else {
        // close all minis
        navPanelItems.querySelectorAll('.navpanel__item-mini').forEach(el => {
          el.style.maxHeight = '';
        });
      }
    };

    // set style.left
    let navPanelPosition = 0;
    const megaToggle = (el, dir) => {
      
      if (dir === undefined) {
        dir = navPanelItems.style.left === `0px` ? 'open' : 'close';
      }

      document.querySelector('#navpanel').scrollTo({
        top: 0,
        behavior: 'instant'
      });
      
      
      if (dir === 'open') {
        // un-hiding
        navbarOpenBtn.classList.add('spt-hidden');
        navbarCloseBtn.classList.add('spt-hidden');
        navbarBackBtn.classList.remove('spt-hidden');
        navPanelBackBtn.classList.remove('spt-hidden');

        // un-hide the next page (el + querySelector the mega)
        el
          .closest('.navpanel__item')
          .querySelector('.navpanel__item-mega')
          .classList.remove('spt-hidden');
        
        // determine how what to set as style.left
        navPanelPosition -= 100;
        // hey im on page 0, let's go style.left -100
        // hey im on page 1, let's go style.left -100 more (-200)
        navPanelItems.style.left = `${navPanelPosition}%`;

        // as we navigate 'in' add data attr for referece when coming back 'up'
        el
        .closest('.navpanel__item')
        .querySelector('.navpanel__item-mega')
        .dataset.position = navPanelPosition;

        console.log(navPanelPosition)
      } else {

        // back button logic

        // hiding
        const megaToHide = Array.from(document.querySelectorAll(`[data-position="${navPanelPosition}"]`)).filter(element => !element.classList.contains('spt-hidden'));

        // "animate back one page"
        navPanelPosition += 100;
        // determine current page via current style.left value?
        navPanelItems.style.left = `${navPanelPosition}%`;
        // hide all megas on current page (the page we want to leave) look at class list open mega to hide
        megaToHide.forEach(element => {
          element.classList.add('spt-hidden');
        });

        if (navPanelItems.style.left === '0%') {
          navbarOpenBtn.classList.add('spt-hidden');
          navbarCloseBtn.classList.remove('spt-hidden');
          navbarBackBtn.classList.add('spt-hidden');
          navPanelBackBtn.classList.add('spt-hidden');

          navPanelItems.querySelectorAll('.navpanel__item-mega').forEach(el => {
            el.classList.add('spt-hidden');
          });
        }
          
      }
    };

    const drawerOpen = () => {
      document.body.classList.add('spt-overflow-hidden');
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

      navbarOpenBtn.classList.add('spt-hidden');
      navbarCloseBtn.classList.remove('spt-hidden');

      overlay.classList.remove('spt-invisible');
      overlay.style.opacity = 1;
      container.style.left = 0;

      if (
        announcementBar &&
        window.innerWidth < 768 &&
        sessionStorage.getItem('cym-announcement-bar-hide') === null
      ) {
        announcementBar.firstChild.style.height = '0px';
      }
      // focus inside?
    };

    const drawerClose = () => {
      // close all megas
      megaToggle(null, 'close');
      miniToggle(null, 'close');
      
      // case from page 2 to page 0
      navbarBackBtn.classList.add('spt-hidden');
      navPanelBackBtn.classList.add('spt-hidden');
      navPanelItems.style.left = '0px';
      navPanelPosition = 0;

      document.body.classList.remove('spt-overflow-hidden');

      navbarOpenBtn.classList.remove('spt-hidden');
      navbarCloseBtn.classList.add('spt-hidden');

      overlay.classList.add('spt-invisible');
      overlay.style.opacity = 0;
      container.style.left = `-${container.offsetWidth}px`;

      if (
        announcementBar &&
        window.innerWidth < 768 &&
        sessionStorage.getItem('cym-announcement-bar-hide') === null
      ) {
        announcementBar.firstChild.style.height = null;
      }
      // focus outside?
    };

    const drawerToggle = () => {
      if (overlay.style.opacity === '0') {
        drawerOpen();
      } else {
        drawerClose();
      }
    };

    document.addEventListener('keydown', e => {
      if (e.keyCode == 27) {
        drawerClose();
      }
    });

    document.querySelectorAll('#navpanel .navpanel__item').forEach(el => {
      if (el.querySelector('.navpanel__item-mini')) {
        el.querySelector('button').addEventListener('click', miniToggle);
      } else if (el.querySelector('.navpanel__item-mega')) {
        // edit code that adds events to nav-panel-item-megas (the open event)
        // find all, add event listener to use el + dir == "open"
        el.querySelector('button').addEventListener('click', function() {
          megaToggle(el, 'open');
        });
      }
    });

    // edit code that adds back button events
    // find all back buttons, add event listener to use el + dir == "close"
    navPanelBackBtn.addEventListener('click',  function() {
      megaToggle(null, 'close');
    });
    navbarBackBtn.addEventListener('click',  function() {
      megaToggle(null, 'close');
    });

    navbarOpenBtn.addEventListener('click', drawerToggle);
    navbarCloseBtn.addEventListener('click', drawerToggle);
    navPanelCloseBtn.addEventListener('click', drawerToggle);
    overlay.addEventListener('click', drawerToggle);

    window.addEventListener('resize', () => {
      if (overlay.style.opacity === '0') {
        container.style.left = `-${container.offsetWidth}px`;
      }
    });
    container.style.left = `-${container.offsetWidth}px`;

    //drawerOpen()
  };

  const initFixedNavBar = () => {
    window.addEventListener('load', () => {
      // document.querySelector('header').classList.add('spt-h-12.5');
      // document.querySelector('header').classList.add('lg:spt-h-14');
      // document.querySelector('header').classList.add('xl:spt-h-15');
    });
    window.addEventListener('scroll', () => {
      if (
        window.pageYOffset >
        document.querySelector('.announcement-bar').offsetHeight
      ) {
        document.querySelector('#navbar-wrapper').classList.add('spt-bg-white');
        document.querySelector('#navbar-wrapper').classList.add('spt-top-0');
        document.querySelector('#navbar-wrapper').classList.add('spt-left-0');
        document.querySelector('#navbar-wrapper').classList.add('spt-w-full');
        document.querySelector('#navbar-wrapper').classList.add('spt-fixed');
        document.querySelector('header').style.color = 'black';
      } else {
        document.querySelector('#navbar-wrapper').classList.remove('spt-bg-white');
        document.querySelector('#navbar-wrapper').classList.remove('spt-top-0');
        document.querySelector('#navbar-wrapper').classList.remove('spt-left-0');
        document.querySelector('#navbar-wrapper').classList.remove('spt-w-full');
        document.querySelector('#navbar-wrapper').classList.remove('spt-fixed');
        document.querySelector('header').style.color = null;
      }
    });
  };

  // put in nav drawer file

  //put in header? Leave here?
  const setHeaderHeight = () => {
    const navBarHeight = document.querySelector('#navbar-wrapper').offsetHeight
    document.querySelector('#shopify-section-layout-header').style.height = `${navBarHeight}px`
  }
  //put in header?

  //put in cart
  const toggleCartSpan = () => {
    let navbarCart = document.getElementById('navbar__cart');
    let cartSpanCount = navbarCart.querySelector('span');
    cartSpanCount.classList.remove('spt-hidden');
  }
  //put in cart

  window.addEventListener('resize', setHeaderHeight)
  setHeaderHeight()

  initCartDrawer();
  initSearchDrawer();
  initNavDrawer();
  initFooterLinks();
  initFixedNavBar();
  toggleCartSpan();
});